import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'horizontal-scroll',
  standalone: true,
  template: `<ng-content />`,
  styleUrl: './horizontal-scroll.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'horizontal-scroll'
  }
})
export class HorizontalScrollComponent {}
